module.exports = __webpack_public_path__ + "media/nonono.0260b9f7.mp3";